import React, { FC } from 'react';

type Size = 'large' | 'medium' | 'small';

import './UserAvatar.scss';

export const UserAvatar: FC<{
  readonly url: string;
  readonly size?: Size;
}> = ({ url, size }) => {
  return (
    <img
      className={size ? `avatar-${size}` : ''}
      loading="lazy"
      referrerPolicy="no-referrer"
      src={url}
    />
  );
};
